import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ImageWrapper from '../common/ImageWrapper';
import { useNavigate, useParams } from 'react-router-dom';

import LocationIcon from '../../assets/icons/location2.svg?react'
import VIcon from '../../assets/icons/VIcon.svg?react'
import ArrowIcon from '../../assets/icons/ArrowIcon.svg?react'
import calendarIcon from '../../assets/icons/calendar.svg'
import { createImageUrl } from '../../services/data';
import { addDefaultSource } from '../../services/errorHandlers';
import { palette } from '../../themes/theme';

interface WalkingTourProps {
  title: string;
  subtitle: string;
  shortDescription?: string;
  date?: string;
  photo: string;
  type: string;
  id: string;
  enabled?: boolean;
  wasViewed?: boolean;
  iconId?: string;
  thumbnailType?: string;
  address?: string;
}

const WalkingTour: React.FC<WalkingTourProps> = ({
  title,
  subtitle,
  shortDescription,
  date,
  photo,
  type,
  id,
  enabled,
  wasViewed,
  iconId,
  thumbnailType,
  address
}) => {
    const navigate = useNavigate()
    const { slug } = useParams()

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/${slug}/${id}`)
    }

    let imageFilter = 'none'
    let textColor = 'black'
    let icon: React.ReactNode

    if (wasViewed) {
      textColor = '#79828E'
      imageFilter = 'grayscale(100%)'
      icon = <VIcon filter='grayscale(100%)'/>
    } else {
      textColor = 'black'
      imageFilter = 'none'
      if (iconId) {
        icon = <img src={createImageUrl(iconId)} alt="icon" onError={addDefaultSource} />
      } else {
        icon = <ArrowIcon color='black'/>
      }
    }

  return (
    <Box onClick={handleClick} sx={{display: 'flex', flexDirection: 'row', gap: '1.2rem', width: '95%', borderRadius: '1.2rem', cursor: 'pointer'}}>
      <Box sx={{flex: 2, borderStartStartRadius: 'inherit', borderEndStartRadius: 'inherit', filter: imageFilter, overflow: 'hidden', aspectRatio: '1/1'}}>
        <ImageWrapper img={photo} width="100%" height="100%" objectFit="cover" borderRadius="0" style={{display: 'block', margin: 0, padding: 0}} />
      </Box>

      <Box sx={{flex: 5, display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '1rem 0', height: 'min-content'}}>
        <Box sx={{display: 'flex', flexDirection: 'row', gap: '0.5rem'}}>
          <img style={{width: '1.5rem', height: '1.5rem'}} src={createImageUrl(iconId)} alt="icon" onError={addDefaultSource} />
          <Typography variant="tour2"
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              textAlign: 'left',
              color: palette.brand.gold,
              backgroundColor: '#ECE9DC',
              padding: '0 1rem',
              borderRadius: '1rem'
            }}
          >{title}</Typography>
        </Box>
        <Typography variant="tour1"
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 600,
          textAlign: 'left',
          mb: 0.375,
          minHeight: 15,
          display: 'inline-block',
          verticalAlign: 'middle',
        }}
        >{subtitle}</Typography>
        {
          thumbnailType !== "minor" && 
          (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <LocationIcon style={{width: '1.5rem', height: '1.5rem', display: 'inline-block', verticalAlign: 'middle'}} />
            <Typography variant="tour2"
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              textAlign: 'left',
              alignItems: 'center',
              mb: 0.5,
              WebkitLineClamp: 1,
              marginInlineStart: '1rem',
              display: 'inline-block',

            }}
            >{shortDescription}</Typography>
          </div>
          )
        }
        {
          thumbnailType === "minor" && 
          (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <LocationIcon style={{width: '1.5rem', height: '1.5rem', display: 'inline-block', verticalAlign: 'middle'}} />
            <Typography variant="tour2"
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              textAlign: 'left',
              alignItems: 'center',
              mb: 0.5,
              WebkitLineClamp: 1,
              marginInlineStart: '1rem',
              display: 'inline-block',

            }}
            >{address}</Typography>
          </div>
          )
        }
        {
          thumbnailType !== "minor" && 
          (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <img style={{width: '1.5rem', height: '1.5rem'}} src={calendarIcon} alt="calendar" />
            <Typography variant="tour2"
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 400,
              textAlign: 'left',
              display: 'inline-block',
              verticalAlign: 'middle',
              marginInlineStart: '1rem',
              WebkitLineClamp: 1,
            }}
            >{date}</Typography>
          </div>
          )
        }

      </Box>

      <Box sx={{alignSelf: 'center'}}>
          <IconButton>
            <ArrowIcon color='black'/>
          </IconButton>
        </Box>
    </Box>
  )

};

export default WalkingTour;
